module.exports = __webpack_public_path__ + "img/manhattan.13d3a7d5.jpg";